import Vue from 'vue';
import VueRouter from 'vue-router';
import PrivacyPolicy from '../components/PrivacyPolicy.vue';
import App from '../App.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: App,

  },
  {
    path: '/polityka-prywatnosci',
    name: 'privacy-policy',
    component: PrivacyPolicy,
    meta: {
      title: 'Polityka Prywatności',
    },
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    return { x: 0, y: 0 };
  },
});

export default router;
